import React from 'react';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { ChangeCardAndDetails } from '../PolicyChangeCard';
import {
  PolicyChangeCard,
  changeTypes,
} from '../PolicyChangeCard/PolicyChangeCard';
import { MultiLinePolicy } from '@clearcover/core-app-types/dist/endpoints/getPolicy/multiLinePolicy';
import { DiscountChangeDetails } from './DiscountChangeDetails';

export const toDiscountChangeCardAndDetails = (
  diff: VersionedObjectDiff<MultiLinePolicy>
): ChangeCardAndDetails => {
  let displayType = diff.type;

  // @TODO try to use typeSpecificData from activity, it might need to add an identifier to each item to match the specific one from each activity as it resturn an array
  if (diff.new?.type === 'none') {
    displayType = 'DELETED';
  } else if (diff.old?.type === 'none') {
    displayType = 'ADDED';
  }

  const title = `Discount ${changeTypes[displayType]}`;
  const value = 'Multi-Line Discount';

  return {
    card: ({ 'data-testid': dataTestId, selected, onClick }) => (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={title}
        onClick={onClick}
        selected={selected}
        type="discount"
        action={displayType}
        value={value}
      />
    ),
    details: () => <DiscountChangeDetails diff={diff} />,
    metadata: {
      type: 'discount',
      action: displayType,
      title,
      value,
    },
  };
};
